import { type ApiClient, getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { type QueryKey, queryOptions } from "@tanstack/react-query";
import type { MetalCommitment } from "@warrenio/api-spec/spec.oats.gen";
import { atomFamily } from "jotai-family";

//#region Response
type Response = MetalCommitment[];
//#endregion

//#region Query and parameters
function getQueryKey(params?: Params): QueryKey {
    return params == null ? ["metal_commitment/list"] : ["metal_commitment/list", params.location];
}

interface Params {
    location: string;
}

function getQuery(client: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<Response> => {
            const { location } = params;
            return getResponseData(
                await client.GET("/{location}/admin/metal/commitments", {
                    signal,
                    params: { path: { location } },
                }),
            );
        },
    });
}
//#endregion

//#region Atoms
export const metalCommitmentLocationQueryAtom = atomFamily((location: string) =>
    atomFromStandardQueryOptions(getQuery, { location }),
);

//#endregion
